import BackArrow from "@/ui/Icons/BackArrow";
import { useRouter } from "next/router";
import Image from "next/image";

export default function NavBar({
  heading,
  component: Component,
  backStyles = "",
  headingImg = "",
  headingStyles = "",
  imgStyles = "",
  imgSize = 64,
  bgColor = "bg-white",
  isRounded = true,
  backURL,
  headingCenter = false,
  headerHeight = "h-16",
  wrapperClass = "",
}: {
  heading: string;
  component?: any;
  backStyles?: string;
  headingImg?: string;
  headingStyles?: string;
  imgStyles?: string;
  imgSize?: number;
  bgColor?: string;
  isRounded?: boolean;
  backURL?: string;
  headingCenter?: boolean;
  headerHeight?: string;
  wrapperClass?: string;
}) {
  const router = useRouter();
  return (
    <div className={[`relative w-full`, headerHeight, wrapperClass].join(" ")}>
      <nav
        className={[
          `flex items-center justify-start gap-2 px-3 py-[13px] fixed top-0 left-1/2 -translate-x-1/2 z-20 w-screen max-w-[34rem]`,
          isRounded ? "rounded-b-2xl" : "",
          bgColor,
        ].join(" ")}
      >
        <button
          className={[`p-3 rounded-lg flex justify-center`, backStyles].join(
            " "
          )}
          onClick={() => (backURL ? router.push(backURL) : router.back())}
        >
          <BackArrow />
        </button>
        <div
          className={[
            `flex align-middle items-center flex-grow`,
            headingCenter ? "justify-center pr-12" : null,
            headingStyles,
          ].join(" ")}
        >
          {headingImg && headingImg != "" && (
            <div
              className={[
                `shrink-0 border-2 border-white rounded-full bg-rose-50 overflow-hidden`,
                imgStyles,
              ].join(" ")}
            >
              <Image
                width={imgSize}
                height={imgSize}
                className="object-cover w-full h-full"
                src={headingImg}
                alt={heading}
              />
            </div>
          )}
          <p className={[`px-[10px] font-semibold text-lg`].join(" ")}>
            {heading}
          </p>
        </div>
        {Component && Component}
      </nav>
    </div>
  );
}
